<template>
	<div class="detail-wrap">
		<el-form ref="editForm" :model="faultCode">
			<div class="d-header clearfix">
				<div class="fl">
					<i class="el-icon-info" />
					{{ dataId ? '查看' : '新增' }}故障编码
				</div>
				<div class="fr">
					<el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置</el-button>
					<el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
				</div>
			</div>
			<div class="d-cont edit-mce-box">
				<div class="d-item">
					<div class="title first"><b>基本信息</b></div>
					<table class="table-detail">
						<tbody>
							<tr>
								<th>
									<em class="f-red">*</em>
									产品分类
								</th>
								<td>
									<el-form-item prop="itemCatName" :rules="[{ required: false, trigger: 'blur' }]">
										<el-input
											class="search-input"
											max="200"
											v-model="faultCode.itemCatName"
											@clear="
												faultCode.itemCatId = '';
												faultCode.itemCatCode = '';
												$forceUpdate();
											"
											v-el-readonly
											clearable
										>
											<i slot="suffix" class="el-input__icon el-icon-search" @click="showProductCategoryDialog = true"></i>
										</el-input>
									</el-form-item>
								</td>
								<th>
									<em class="f-red">*</em>
									语言
								</th>
								<td>
									<el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
										<el-select v-model="faultCode.languageId" @change="changeLanguage">
											<el-option
												v-for="languageDTO in languageDTOs"
												:key="'languageDTO' + languageDTO.id"
												:value="languageDTO.id"
												:label="languageDTO.language"
											></el-option>
										</el-select>
									</el-form-item>
								</td>
								<th>设置</th>
								<td><el-checkbox label="是否启用" v-model="enabled"></el-checkbox></td>
								<th class="no"></th>
								<td></td>
							</tr>
							<tr>
								<th>视频链接</th>
								<td colspan="3">
									<el-form-item prop="vodioUrl" :rules="[{ required: true, trigger: 'blur' }]">
										<el-input type="text" autocomplete="off" v-model="faultCode.vodioUrl" clearable />
									</el-form-item>
								</td>
								<th>备注</th>
								<td colspan="3">
									<el-input type="textarea" :rows="2" placeholder="请输入内容" size="small" v-model="faultCode.faultDescription" clearable></el-input>
								</td>
							</tr>
							<tr>
								<th>故障描述</th>
								<td colspan="3"><tinymce v-model="faultCode.faultDescription" :language="lan" :height="300" /></td>
								<th>故障原因</th>
								<td colspan="3"><tinymce v-model="faultCode.faultReason" :language="lan" :height="300" /></td>
							</tr>
							<tr>
								<th>触发条件</th>
								<td colspan="3"><tinymce v-model="faultCode.triggerCondition" :language="lan" :height="300" /></td>
								<th>解决方案</th>
								<td colspan="3"><tinymce v-model="faultCode.solution" :language="lan" :height="300" /></td>
							</tr>
							<tr>
								<th>创建人</th>
								<td>{{ faultCode.createBy }}</td>
								<th>创建时间</th>
								<td>{{ faultCode.createDate }}</td>
								<th>更新人</th>
								<td>{{ faultCode.modifyBy }}</td>
								<th>更新时间</th>
								<td>{{ faultCode.modifyDate }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="d-item">
					<div class="title"><b>附件信息</b></div>
					<table class="table-detail">
						<tbody>
							<tr>
								<td colspan="8"><baseUpload accept="file" multi="true" :file.sync="faultCode.faultCodeAttachmentDTOs"></baseUpload></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</el-form>
		<productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false" @confirm="confirmCategory" />
	</div>
</template>

<script>
import Tinymce from '@/components/Tinymce';
export default {
	name: 'faultCodeEdit',
	props: {
		_dataId: [String, Number]
	},
	components: {
		Tinymce,
	},
	data() {
		return {
			lan: 'zh_CN',
			isEdit: false,
			tabIndex: 'first',
			dataId: '',
			faultCode: { stat: null, faultCodeAttachmentDTOs: [] },
			showProductCategoryDialog: false,
			languageDTOs: []
		};
	},
	computed: {
		enabled: {
			get: function() {
				if (this.faultCode.stat == 1) {
					return true;
				} else if (this.faultCode.stat == 9) {
					return false;
				} else {
					return false;
				}
			},
			set: function(newValue) {
				if (newValue) {
					this.faultCode.stat = 1;
				} else {
					this.faultCode.stat = 9;
				}
			}
		}
	},
	created() {
		if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
	},
	mounted() {
		this.initLauguage();
		this.getData();
	},
	methods: {
		getData() {
			if (this.dataId && !isNaN(this.dataId)) {
				this.isEdit = true;
				this.$http({
					url: HXFW_PREFIX + `/fault/code/get`,
					method: `post`,
					data: {
						id: this.dataId
					},
					isLoading: true,
					modalStrictly: true,
					success: res => {
						this.faultCode = res.objx || {};
						this.initAttachments();
					}
				});
			} else {
				this.enabled = true;
			}
		},
		saveData() {
			this.$refs.editForm.validate(valid => {
				if (valid) {
					this.$baseConfirm('您确定要保存吗？').then(() => {
						var url = HXFW_PREFIX + (this.isEdit ? `/fault/code/update` : `/fault/code/save`);
						this.$http({
							url: url,
							method: `post`,
							data: this.faultCode,
							isLoading: true,
							success: res => {
								this.$message({
									message: res.content,
									type: 'success',
									duration: 500,
									onClose: t => {
										if (this.isEdit) {
											this.$baseReload();
										} else {
											this.$baseReload({
												updateParam: {
													_dataId: res.objx
												}
											});
										}
									}
								});
							}
						});
					});
				}
			});
		},
		confirmCategory(rows) {
			if (rows.length > 0) {
				let row = rows[0];
				this.faultCode.itemCatId = row.id;
				this.faultCode.itemCatName = row.categoryName;
				this.faultCode.itemCatCode = row.categoryCode;
			}
		},
		initLauguage() {
			this.$http({
				url: HXFW_PREFIX + `/lauguage/lists`,
				method: `post`,
				data: {},
				isLoading: true,
				modalStrictly: true,
				success: res => {
					this.languageDTOs = res.objx || [];
					if (!this.dataId) {
						this.languageDTOs.some(row => {
							let flag = row.language == '中文';
							if (flag) {
								this.faultCode.languageId = row.id;
								this.faultCode.languageName = row.language;
								this.faultCode.languageCode = row.languageCode;
							}
							return false;
						});
					}
				}
			});
		},
		changeLanguage(value) {
			if (value) {
				let rows = this.languageDTOs.filter(row => row.id == value);
				if (rows.length) {
					let row = rows[0];
					this.faultCode.languageName = row.language;
					this.faultCode.languageCode = row.languageCode;
				}
			} else {
				this.faultCode.languageName = null;
				this.faultCode.languageCode = null;
			}
		},
		initAttachments() {
			if (this.dataId) {
				this.$http({
					url: HXFW_PREFIX + `/fault/code/getFaultCodeAttachments`,
					method: `post`,
					data: { id: this.dataId },
					isLoading: true,
					modalStrictly: true,
					success: res => {
						this.faultCode.faultCodeAttachmentDTOs = res.objx || [];
					}
				});
			}
		}
	}
};
</script>
